module.exports = "//static.hsappstatic.net/LoginUI/static-1.15074/img/HubSpot-sprocket-color.png"